"use strict";

exports.__esModule = true;
exports.CurrentClassificationContext = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Shared current-classification device states and registration API.
 *
 * value shape:
 * {
 *   deviceStates: { [deviceUuid]: stateId },
 *   registerDevices: (deviceUuids: string[]) => () => void,
 * }
 */
var CurrentClassificationContext = exports.CurrentClassificationContext = /*#__PURE__*/_react["default"].createContext({
  deviceStates: {},
  registerDevices: function registerDevices() {
    return function () {};
  }
});
CurrentClassificationContext.displayName = "CurrentClassificationContext";